<template>
  <v-card>
    <div class="d-flex justify-space-between">
      <div>
        <v-card-title> Distribuição de empresas </v-card-title>
        <v-card-subtitle> Margem por tipo de empresa </v-card-subtitle>
        <v-card-text class="text-no-wrap mt-4">
          <p class="text-xs mb-0">Total de empresas Cadastradas</p>
          <span class="text-xl font-weight-semibold text--primary me-1"
            >{{ companiesTotal }}
          </span>
        </v-card-text>
      </div>

      <vue-apex-charts
        id="chart-stats-total-sales"
        height="140"
        :options="chartOptions"
        :series="chartSeries"
      />
    </div>
  </v-card>
</template>

<script>
import VueApexCharts from "vue-apexcharts";

import { mdiChevronUp } from "@mdi/js";
import { getVuetify } from "@core/utils";

export default {
  props: {
    marginByType: {
      companyAffiliate: Number,
      companydropshipper: Number,
      companyProducer: Number,
    },

    companiesCount: {
      activeCompaniesTotal: Number,
      inativeCompaniesTotal: Number,
    },
  },
  components: {
    VueApexCharts,
  },
  data() {
    return {
      companiesTotal: null,
      chartSeries: [],

      chartOptions: {
        chart: {
          offsetY: 7,
          type: "donut",
          sparkline: {
            enabled: true,
          },
          animations: {
            enabled: false,
          },
        },
        stroke: {
          colors: ["#fff"],
          width: 8,
        },
        grid: {
          padding: {
            bottom: 10,
          },
        },
        colors: [
          this.$vuetify.theme.currentTheme.primary,
          "#64B5F6",
          this.$vuetify.theme.currentTheme.secondary,
        ],

        labels: ["Afiliados", "Dropshippers", "Produtores"],

        plotOptions: {
          pie: {
            donut: {
              labels: {
                show: true,
                name: {
                  fontSize: "14px",
                  offsetY: 25,
                },
                value: {
                  offsetY: -13,
                  formatter(value) {
                    return `${value}`;
                  },
                },
              },
            },
          },
        },
      },
      icons: {
        mdiChevronUp,
      },
    };
  },

  watch: {
    companiesCount: {
      handler: function (value, oldValue) {
        this.companiesTotal =
          this.companiesCount.activeCompaniesTotal +
          this.companiesCount.inativeCompaniesTotal;
      },
      deep: true,
    },

    marginByType: {
      handler: function (value, oldValue) {
        this.chartSeries = [
          this.marginByType.companyAffiliate,
          this.marginByType.companydropshipper,
          this.marginByType.companyProducer,
        ];
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss">
#chart-stats-total-sales {
  max-width: 150px;
  height: auto;
  .apexcharts-pie {
    .apexcharts-pie-series .apexcharts-pie-area {
      stroke-width: 10;
    }
  }
  .apexcharts-canvas {
    .apexcharts-text {
      &.apexcharts-datalabel-value {
        font-weight: 600;
        font-size: 1.25rem;
      }
      &.apexcharts-datalabel-label {
        font-size: 0.75rem;
        margin-bottom: 2rem;
        transform: translateY(-7px);
      }
    }
  }
}

.v-application {
  &.theme--dark {
    #chart-stats-total-sales {
      path {
        stroke: #312d4b;
      }
    }
  }
}
</style>
